import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../assets/logo/logo1.jpeg';
function Footer() {
  const romanToDevanagari = {
    '0': '०', '1': '१', '2': '२', '3': '३', '4': '४',
    '5': '५', '6': '६', '7': '७', '8': '८', '9': '९'
  };

  const convertToDevanagari = (num) => {
    return String(num).split('').map(d => romanToDevanagari[d]).join('');
  };

  const currentYear = convertToDevanagari(new Date().getFullYear());

  return (
    <footer className="footer" role="contentinfo" aria-label="पाद लेख">
      <div className="footer-container container">
        <div className="footer-grid">
          {/* संक्षिप्त परिचय */}
          <div className="footer-section footer-about">
            <div className="footer-logo">
              <span className="footer-logo-emoji">
                <img src={logo} alt="लठ्ठ साब लोगो" className="footer-logo-image" />
              </span>
            </div>
            <h4 className="footer-title">लाठ  साब</h4>
            <p className="footer-tagline">चित्रकूट की प्रमुख खबरें</p>
            <p className="footer-desc">
              भारत की सबसे विश्वसनीय जिला समाचार वेबसाइट। प्रामाणिक खबरें, राजनीतिक विश्लेषण और जमीनी रिपोर्टिंग आपके लिए।
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/profile.php?id=61581570867016&sfnsn=wa" target="_blank" rel="noopener noreferrer" title="फेसबुक" aria-label="फेसबुक">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M20 10a10 10 0 10-11.56 9.9v-7h-2.5V10h2.5V7.8c0-2.47 1.47-3.83 3.72-3.83 1.08 0 2.21.19 2.21.19v2.43h-1.24c-1.23 0-1.61.76-1.61 1.55V10h2.73l-.44 2.9h-2.29v7A10 10 0 0020 10z" />
                </svg>
              </a>
              <a href="https://youtube.com/@laathsaab96?si=wcF1ks5RSuvgM9IS" target="_blank" rel="noopener noreferrer" title="यूट्यूब" aria-label="यूट्यूब">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M18 0H2C.9 0 0 .9 0 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-2 11.5s0 3.6-3.6 3.6H7.6c-3.6 0-3.6-3.6-3.6-3.6V8.4s0-3.6 3.6-3.6h4.8c3.6 0 3.6 3.6 3.6 3.6v3.1zM8 14l4.5-2.5L8 9v5z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/laathsaab_96?utm_source=qr&igsh=MWI3ZWIxcTJoN3Zoeg==" target="_blank" rel="noopener noreferrer" title="इंस्टाग्राम" aria-label="इंस्टाग्राम">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7.75 2C4.57 2 2 4.57 2 7.75v8.5C2 19.43 4.57 22 7.75 22h8.5C19.43 22 22 19.43 22 16.25v-8.5C22 4.57 19.43 2 16.25 2h-8.5zm0 2h8.5C18.01 4 20 5.99 20 7.75v8.5C20 18.01 18.01 20 16.25 20h-8.5C5.99 20 4 18.01 4 16.25v-8.5C4 5.99 5.99 4 7.75 4zm9.25 1.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM12 7a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6z" />
                </svg>
              </a>
              <a href="https://whatsapp.com" target="_blank" rel="noopener noreferrer" title="व्हाट्सएप" aria-label="व्हाट्सएप">
                <svg width="20" height="20" viewBox="0 0 32 32" fill="currentColor">
                  <path d="M19.11 17.56c-.27-.13-1.6-.79-1.85-.88-.25-.09-.43-.13-.61.13-.18.27-.7.88-.86 1.06-.16.18-.31.2-.58.07-.27-.13-1.15-.42-2.19-1.35-.81-.72-1.36-1.61-1.52-1.88-.16-.27-.02-.41.12-.54.13-.13.27-.34.4-.5.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.13-.61-1.47-.84-2.02-.22-.53-.45-.46-.61-.47h-.52c-.18 0-.47.07-.71.34-.25.27-.96.94-.96 2.29 0 1.35.99 2.65 1.13 2.83.13.18 1.95 2.98 4.73 4.18.66.28 1.17.45 1.57.58.66.21 1.27.18 1.75.11.53-.08 1.6-.65 1.83-1.27.22-.63.22-1.17.16-1.27-.06-.11-.25-.18-.52-.31zM16 3C8.83 3 3 8.83 3 16c0 2.26.6 4.39 1.65 6.24L3 29l6.93-1.61C11.66 28.41 13.79 29 16 29c7.17 0 13-5.83 13-13S23.17 3 16 3zm0 23.64c-1.97 0-3.82-.53-5.42-1.46l-.39-.23-4.11.95.87-4.01-.25-.41A10.64 10.64 0 0 1 5.36 16c0-5.86 4.78-10.64 10.64-10.64S26.64 10.14 26.64 16 21.86 26.64 16 26.64z" />
                </svg>
              </a>
            </div>
          </div>

          {/* त्वरित लिंक */}
          <div className="footer-section">
            <h5 className="footer-subtitle">🔗 त्वरित लिंक</h5>
            <ul className="footer-links">
              <li><Link to="/">होम</Link></li>
              <li><Link to="/news">जिला</Link></li>
              <li><Link to="/gallery">ब्लॉक</Link></li>
              <li><Link to="/videos">वीडियो</Link></li>
              <li><Link to="/about">टीम</Link></li>
            </ul>
          </div>

          {/* जानकारी */}
          <div className="footer-section">
            <h5 className="footer-subtitle">ℹ️ जानकारी</h5>
            <ul className="footer-links">
              <li><Link to="/about">हमारे बारे में</Link></li>
              <li><Link to="/contact">संपर्क करें</Link></li>
              <li><button className="footer-link-btn">गोपनीयता नीति</button></li>
              <li><button className="footer-link-btn">नियम और शर्तें</button></li>
              <li><button className="footer-link-btn">विज्ञापन नीति</button></li>
            </ul>
          </div>

          {/* न्यूज़लेटर */}
          <div className="footer-section footer-newsletter-section">
            <h5 className="footer-subtitle">📧 न्यूज़लेटर</h5>
            <p className="footer-newsletter-desc">
              सभी खबरें सीधे आपके ईमेल में पाएं
            </p>
            <form className="footer-newsletter" aria-label="न्यूज़लेटर सदस्यता">
              <input
                type="email"
                placeholder="आपका ईमेल पता दर्ज करें"
                aria-label="ईमेल"
                required
              />
              <button type="submit" className="btn btn-primary btn-newsletter">
                सदस्य बनें
              </button>
            </form>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} <strong>लाठ साब</strong> | सर्वाधिकार सुरक्षित। सभी अधिकार सुरक्षित हैं।
          </p>
          <p className="footer-credit">
            <small>
              💚 देशभक्ति और पत्रकारिता की भावना से बनाया गया | गुणवत्ता और सत्यता हमारा मूलमंत्र
            </small>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
